import { SocialIcon } from 'react-social-icons'
import { FaLocationDot, FaPhone   } from "react-icons/fa6";
import { Link } from "react-router-dom";


const Footer = () => {
    return (
    <div className="footerDivContainer">
      <div className="footerDiv">

        <div className='socialFotterContainer'>
          <SocialIcon url="https://x.com" />
          <SocialIcon url="https://www.facebook.com/AliFabsCoping" />
          <SocialIcon url="mailto:info@mucksucker.co.uk"/>
        </div>
        <div className="addressFooter">
        <p className="footerText">
        <FaLocationDot /> Trevor Morris Building, Queen Elizabeth Drive, Oswestry, SY11 2UQ</p>

        </div>

        <div className='ContactFooterContainerMaster'>
          <div className='ContactFooterContainerSub'>
            <a href="tel:441691900900" className="footerTextContainer">
              <FaPhone  />
              <p className="footerTextContact">+44(0)1691 900 900</p>
            </a>

            <a href="https://api.whatsapp.com/send?phone=441691907888" className="footerTextContainer">
              <SocialIcon url="https://whatsapp.com" />
              <p className="footerTextContact">+44 1691 907888</p>
            </a>
          </div>
        </div>

        <div className="footerLinksContainer">
          <div className="footerLinks">
            <div className="navContainerFooter">
              <ul className="navMenuFooter">
                  <li>
                    <Link className="navMenuFooterText" to="/cookie">Cookie Policy</Link>
                  </li>
                  <li>
                    <Link className="navMenuFooterText" to="/privacy">Privacy Policy</Link>
                  </li>
                </ul>
            </div>

          </div>

        </div>

      </div>    
    </div>    
    );
  };
  
  export default Footer;